exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product.collection-product[data-v-a968b24c]{padding-right:0;width:auto;margin:20px !important}@media (max-width: 767px){.product.collection-product[data-v-a968b24c]{margin:0 !important;max-width:190px}}\n", ""]);

// exports
